module.exports = __webpack_public_path__ + "media/גדול.49253c1b.mp3";